import { usePaging } from 'hooks/usePaging';
import { useGetContactHistoriesQuery } from 'services';
import { FindAllContactHistoryDto } from 'types/dto/contacts';
import { DEFAULT_PAGE_SIZE } from 'utils';

const pageSize = DEFAULT_PAGE_SIZE;
export function useContactHistoriesPaging(params: Omit<FindAllContactHistoryDto, 'pageSize'>, enabled = true) {
  const { contactId, address, customerCode, districtId, keyword, name, phoneNumber, ticketId, wardId } = params;
  const { pageIndex, changePage, resetPage } = usePaging(params);
  const {
    data: historiesResponse,
    error,
    isFetching,
    isLoading
  } = useGetContactHistoriesQuery(
    {
      pageIndex,
      pageSize,
      keyword,
      contactId,
      name,
      phoneNumber,
      address,
      customerCode,
      wardId,
      districtId,
      ticketId
    },
    {
      refetchOnMountOrArgChange: true,
      skip: !enabled
    }
  );
  const handleChangePage = changePage;

  return {
    contactHistories: historiesResponse?.data.rows,
    count: historiesResponse ? historiesResponse.data.count : 0,
    isLoading: isFetching || isLoading,
    pageSize,
    pageIndex,
    handleChangePage,
    resetPage,
    error
  };
}
